import type { Dispatch, FC, ReactNode, SetStateAction } from "react";

import { createContext, useState, useContext } from "react";

interface EditCampaignContextProps {
  detectedChange: boolean;
  reset: boolean;
  save: boolean;
  setDetectedChange: Dispatch<SetStateAction<boolean>>;
  setReset: Dispatch<SetStateAction<boolean>>;
  setSave: Dispatch<SetStateAction<boolean>>;
}

const EditCampaignContext = createContext<EditCampaignContextProps | null>(
  null,
);

interface EditCampaignProviderProps {
  children: ReactNode;
}

export const EditCampaignProvider: FC<EditCampaignProviderProps> = ({
  children,
}) => {
  const [detectedChange, setDetectedChange] = useState<boolean>(false);
  const [reset, setReset] = useState<boolean>(false);
  const [save, setSave] = useState<boolean>(false);

  const value: EditCampaignContextProps = {
    detectedChange,
    reset,
    save,
    setDetectedChange,
    setReset,
    setSave,
  };

  return (
    <EditCampaignContext.Provider value={value}>
      {children}
    </EditCampaignContext.Provider>
  );
};

export const useEditCampaign = (): EditCampaignContextProps => {
  const context = useContext(EditCampaignContext);
  if (!context) {
    throw new Error(
      "useEditCampaign must be used within a EditCampaignProvider",
    );
  }
  return context;
};
